var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"base-accordion-item",attrs:{"data-cy":"accordion"}},[_c('BaseButton',{staticClass:"sf-button--pure base-accordion-item__header",class:{ 'is-open': _vm.amIOpen },on:{"click":_vm.accordionClick}},[_vm._v("\n    "+_vm._s(_vm.header)+"\n\n    "),_vm._t("additional-info"),_vm._v(" "),(!_vm.alwaysOpen)?_c('BaseChevron',{staticClass:"base-accordion-item__chevron",class:{
        'sf-chevron--top':
          (!_vm.amIOpen && _vm.chevronPositions.closed === 'up') ||
          (_vm.amIOpen && _vm.chevronPositions.open === 'up'),
        'sf-chevron--right':
          (!_vm.amIOpen && _vm.chevronPositions.closed === 'right') ||
          (_vm.amIOpen && _vm.chevronPositions.open === 'right'),
        'sf-chevron--left':
          (!_vm.amIOpen && _vm.chevronPositions.closed === 'left') ||
          (_vm.amIOpen && _vm.chevronPositions.open === 'left'),
      },attrs:{"tabindex":"0"}}):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"base-accordion-item__content",class:{ expand: _vm.amIOpen }},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }